import { createAction, createSlice } from '@reduxjs/toolkit';

export const addResources = createAction('resources/addResources');

const resourceCardsSlice = createSlice({
  name: 'resources',
  initialState: [],
  reducers: {
    addResources(state, action) {
      return [...action.payload];
    },
  },
});

export default resourceCardsSlice.reducer;
